
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';


export function getUpdateBudgetAccountSortableRankItemDtoFormGroup() {
return new FormGroup({
    budgetAccountId: new FormControl<number | undefined>(undefined, [Validators.required, Validators.min(1)]),
    sortableRank: new FormControl<number | undefined>(undefined, [Validators.required]),
})
;
}
      